<!--
 * @Description: 
 * @Date: 2019-01-15 19:30:59
 -->
<template>
  <div @touchmove="preLoad(getPre)">
    <img class="banner" :src="detail.bgUrl" alt="" />
    <div class="hasPadding">
      <div class="des_box vux-1px-b">
        <p class="des_p1 cl">
          <span>专区</span>
          <span>{{ detail.title }}</span>
        </p>
        <p class="des_p2">
          <span>{{ detail.videoNum }}课程</span>
          <span>·</span>
          <span>{{ detail.subNum }}订阅</span>
        </p>
        <p class="des_p3 cl">
          <span>{{ detail.summary }}</span>
          <span @click="showDes">
            简介
            <i
              :class="[
                'icon',
                'iconfont',
                show ? 'icon-packup' : 'icon-unfold'
              ]"
            ></i>
          </span>
        </p>
      </div>
      <div
        class="html_centent vux-1px-b"
        v-show="show"
        v-html="detail.lecturerIntroduction"
      ></div>
      <contentList v-if="hasSelectByChannelList"></contentList>
      <relation-list
        v-else
        :list="listData"
        :detail-obj="detail"
      ></relation-list>
    </div>
  </div>
</template>
<script>
import RelationList from '../components/list.vue';

import contentList from '@/components/List/contentList.vue';
import { zone, shareCallback } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';

export default {
  name: '',
  mixins: [loadMore],

  data() {
    return {
      hasSelectByChannelList: true, // 是否使用新组件
      show: false,
      detail: {},
      params: {
        id: this.$route.params.id,
        pageNo: 1,
        pageSize: 10
      },
      loadFlag: true,
      listData: []
    };
  },
  methods: {
    showDes() {
      this.show = !this.show;
    },
    getDetail() {
      zone
        .doDetail({
          id: this.$route.params.id
        })
        .then(res => {
          let resp = res.data.data;
          this.detail = resp;

          let vm = this;
          let wxUserInfoObj = this.$api.getStorage('wxUserInfo');

          sa.track('open_channel', {
            channel_id: vm.$route.params.id,
            channel_name: vm.detail.title,
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            distinctId: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            from: 'wx'
          });

          this.$sa.re_zone({
            event_type: '进入',
            zonename: resp.title, // 消费类型 直播，录播，资讯，病例，看课时长上报
            zoneid: resp.id
          });
          /*
           * 分享
           * */
          let shareCallBackFunc = () => {
            shareCallback({
              isChannel: 1
            }).then(res => {
              if (res.data.status != '0') {
                //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
                this.$vux.toast.show({
                  text: '恭喜您获得3积分',
                  type: 'success',
                  width: '5rem'
                });
              } else {
                //您已获得今天全部分享 积分每天前5次分享均可获得3积分
                this.$vux.toast.show({
                  text: '分享成功!',
                  type: 'success',
                  width: '5rem'
                });
              }
              this.$sa.re_zone({
                event_type: '分享',
                zonename: resp.title, // 消费类型 直播，录播，资讯，病例，看课时长上报
                zoneid: resp.id // 内容名字
              });
            });
          };
          this.$wxShareInfo(
            this.detail.shareTitle || resp.title,
            this.detail.shareDescription || resp.summary,
            this.detail.shareImg ||
              'http://cdn.yxvzb.com/newWechat/image/logo98.png',
            location.href,
            '',
            shareCallBackFunc
          );
        });
    },

    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        zone.relationResourceItem(data).then(res => {
          let resp = res.data.data.list;
          for (let i = 0; i < resp.length; i++) {
            this.listData.push(resp[i]);
          }
          if (resp.length < this.params.pageSize) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo++;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(this.params);
    }
  },
  computed: {},
  components: {
    contentList,
    RelationList
  },
  mounted() {
    this.getDetail();
    this.getPre();
  },
  created() {
    this.$eventBus.$on('hasSelectByChannelList', state => {
      this.hasSelectByChannelList = state;
    });
  }
};
</script>
<style lang="less" scoped>
.banner {
  display: block;
  max-width: 100%;
  width: 10rem;
  height: 4.7733rem;
  margin-bottom: 0.56rem;
}

.des_box {
  /*border-bottom: 1px solid #EBEBEB;*/
  padding-bottom: 0.4rem;
  margin-bottom: 0.4rem;
  * {
    font-size: 0.32rem;
  }
  .des_p1 {
    /*display: flex;*/
    /*align-items: center;*/
    /*flex-wrap: wrap;*/
    width: 100%;
    span:nth-of-type(1) {
      float: left;
      width: 1.12rem;
      height: 0.533rem;
      background-image: linear-gradient(-90deg, #f76b1c 0%, #fad961 100%);
      border-radius: 0.08rem;
      text-align: center;
      line-height: 0.533rem;
      color: #fff;
      margin-right: 0.266rem;
    }
    span:nth-of-type(2) {
      font-size: 0.4266rem;
      float: left;
      width: 80%;
      min-height: 0.533rem;
      line-height: 0.533rem;
    }
  }
  .des_p2 {
    margin-top: 0.18rem;
  }
  .des_p3 {
    margin-top: 0.12rem;
    color: #999;
    span:nth-of-type(2) {
      float: right;
    }
  }
}

.html_centent {
  padding-bottom: 0.4rem;
  /*border-bottom: 1px solid #EBEBEB;*/
}
</style>
